import React from 'react'
import Slider from 'react-slick'


const logos = [
  "/assets/images/about-slide-1.webp",
  "/assets/images/about-slide-2.webp",
  "/assets/images/about-slide-3.webp",
  "/assets/images/about-slide-4.webp",
  "/assets/images/about-slide-5.webp",
  "/assets/images/about-slide-6.webp",
  "/assets/images/about-slide-7.webp",
  "/assets/images/about-slide-8.webp",
  "/assets/images/about-slide-9.webp",
  "/assets/images/about-slide-10.webp",
  "/assets/images/about-slide-11.webp",
]


var settings = {
  dots: false,
  slidesToShow: 6,
  infinite: true,
  autoplay: true,
  slidesToScroll: 1,
  pauseOnHover: false,
  arrows: false,
  cssEase: "linear",
  autoplaySpeed: 0,
  speed: 5000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 599,
      settings: {
        slidesToShow: 2,
      },
    },],
};


export default function AboutTeamSlide() {
  return (
    <>
      <section className="about-team-area">
        <h3 className="heading center-heading">Driving productivity for businesses globally</h3>
        <Slider {...settings}>
          {logos?.map((logo, index) => (
            <div key={index} className="about-ream-slide">
              <img src={logo} alt="client-logo" />
            </div>
          ))}
        </Slider>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="about-team-content">
                <img src="/assets/images/about-quote.webp" alt="Assets" />
                <span>The exceptional support from Dox and Box’s team ensured a smooth and efficient transition to our platform, enabling seamless document management. Now, your employees gain access to all essential document handling capabilities—at a significantly optimized cost.</span>
                <label>Ritesh Verma</label>
                <small>General Manager</small>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
